import {
  NgModule,
  ModuleWithProviders,
  SkipSelf,
  Optional,
  NgModuleRef,
  InjectionToken,
} from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { ApiConfigManager, ApiConfigOptions, ModuleSourceInfo } from '@sg/api/base-api-lib';
import {
  LegalEntitiesApiClient,
  LegalEntitiesGroupApiClient,
  LegalEntitiesReservationsApiClient,
  LegalEntitiesAnalyzerUploadsApiClient,
} from './services';
import { LegalEntitiesApiConfig } from './api-config';

declare module '../../../base-api-lib/src/lib/api-config-manager' {
  interface ApiConfigOptionsStore {
    legalEntitiesApiConfig?: ApiConfigOptions;
  }
  interface ApiConfigManager {
    legalEntitiesApiConfig: LegalEntitiesApiConfig;
  }
}

export const CONFIG_FACTORY_TOKEN = new InjectionToken('LegalEntitiesApiModule Config Factory');

@NgModule({
  imports: [],
  declarations: [],
  exports: [],
  providers: [
    LegalEntitiesApiClient,

    LegalEntitiesGroupApiClient,

    LegalEntitiesReservationsApiClient,

    LegalEntitiesAnalyzerUploadsApiClient,
  ],
})
export class LegalEntitiesApiModule {
  public static forRoot(
    configFactory?: (cfgMgr?: ApiConfigManager) => LegalEntitiesApiConfig,
  ): ModuleWithProviders<LegalEntitiesApiModule> {
    return {
      ngModule: LegalEntitiesApiModule,
      providers: [{ provide: CONFIG_FACTORY_TOKEN, useValue: configFactory }],
    };
  }

  constructor(
    cfgMgr: ApiConfigManager,
    moduleRef: NgModuleRef<any>,
    @Optional() @SkipSelf() parentModule: LegalEntitiesApiModule,
    @Optional() http: HttpClient,
  ) {
    if (parentModule) {
      throw new Error(
        'LegalEntitiesApiModule is already loaded. Import in your base AppModule only.',
      );
    }
    if (!http) {
      throw new Error(
        'You need to import the HttpClientModule in your AppModule! \n' +
          'See also https://github.com/angular/angular/issues/20575',
      );
    }

    const configFactory: (cfgMgr?: ApiConfigManager) => LegalEntitiesApiConfig =
      moduleRef.injector.get<any>(CONFIG_FACTORY_TOKEN);
    const config = configFactory
      ? configFactory(cfgMgr)
      : new LegalEntitiesApiConfig(cfgMgr.withBase(cfgMgr.getRawConfig('legalEntitiesApiConfig')));
    cfgMgr.addApiConfig('legalEntitiesApiConfig', config);
  }
}
